export default __webpack_public_path__ + "static/media/13.c59c5592.webp";